import HomepageProducts from './HomepageProducts'
import About from './CarouselAbout'
import Newsletter from './Newsletter/Newsletter'

export { HomepageProducts, About, Newsletter }
export { HeroSection } from './HeroSection'
export { BodySections } from './BodySections/BodySections'
